export default "__VITE_ASSET___i7GZsj$__"